import { Box, Modal, Typography } from "@mui/material";
import { useStyles, modalStyles } from "./ModalShiftDeletion.styles";
import { IModalShiftDeletion } from "./ModalShiftDeletionInterfaces";

export const ModalShiftDeletion = ({ open, handleClose, title, children }: IModalShiftDeletion) => {
    const classes = useStyles();
    return (
        <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box sx={modalStyles}>
                <Typography className={classes.modalTitle}>{title}</Typography>
                <Box className={classes.bodyContainer}>{children}</Box>
            </Box>
        </Modal>
    );
};
